export default __webpack_public_path__ + "static/media/party.8ae90750.svg";